import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptClarity } from '/src/node_modules/@nuxt/scripts/dist/runtime/registry/clarity.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const clarity = useScriptClarity({"id":"vtn3rzpwye"})
    return { provide: { scripts: { clarity } } }
  }
})